import { devices, spacing } from '../../config/theme'
import {
  flexColSpaceBetween,
  widthHeight100,
  height100,
  marginPadding0
} from '../../utils/jss-utils'

const style = {}

style.base = {
  ...height100,
  '& form': {
    '& input[type="text"]': {
      '&::placeholder': {
        color: '#c1c1c1 !important'
      }
    },
    ...widthHeight100,
    ...flexColSpaceBetween,
    '&> div:first-child': {
      ...marginPadding0
    }
  },
  fontSize: '15px !important',
  fontWeight: 'light !important',
  backgroundColor: 'rgba(255,255,255,.6)',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none !important'
  },
  overflowX: 'hidden',
  '-webkit-overflow-scrolling': 'touch'
}

style.base[devices.mobile] = {
  width: '100%'
}

style.base[devices.desktop] = {
  width: '465px',
  maxWidth: '700px',
  maxHeight: '700px',
  padding: spacing.outterContent * 0.75
}

export default style
